import React from "react";

const ProductTypeRepairReportField = ({ record }) => {
  return record.product ? <div>{record.product.product_type}</div> : <div />;
};

export default ProductTypeRepairReportField;
